













































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ExpulsionOrderShort as IExpulsionOrderShort } from "@/api/models/expulsion-order-short";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";

@Component({
  components: { DeleteMaterialModal }
})
export default class expulsionOrderItem extends Vue {
  @Prop() expulsionOrder!: IExpulsionOrderShort;
  showDeleteModal: boolean = false;

  get course() {
    return this.expulsionOrder?.course;
  }

  get courseLink() {
    const courseV1 = {
      name: "courseView",
      params: { courseId: this.course?.id }
    };
    const courseV2 = {
      name: "course",
      params: { id: this.course?.id }
    };

    return this.course?.version === "v1" ? courseV1 : courseV2;
  }

  showDeleteForm() {
    this.showDeleteModal = true;
  }

  hideDeleteModal() {
    this.showDeleteModal = false;
  }

  deleteExpulsion() {
    api.ExpulsionOrderApi._delete(this.expulsionOrder.id)
      .then(() => {
        this.showDeleteModal = false;
        this.$emit("deleteExpulsionOrder");
      })

      .catch((error: AxiosError<IValidationErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(`${error.response.data.message}`, {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          });
        } else {
          this.$bvToast.toast(`${this.$tc(this.$translate.Error)}`, {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          });
        }
      });
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
